import { render, staticRenderFns } from "./CadastrarRecepcionistaUnidade.vue?vue&type=template&id=679426c2"
import script from "./CadastrarRecepcionistaUnidade.vue?vue&type=script&lang=js"
export * from "./CadastrarRecepcionistaUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports